import {
  Box,
  Breakpoint,
  Dialog,
  Divider,
  IconButton,
  SxProps,
  Typography,
  useTheme,
} from "@mui/material";
import { CircleX } from "lucide-react";

import { textStyle } from "@utils/cssStyles";

interface IDialogComponentProps {
  isShowModal: boolean;
  showModalMethod: () => void;
  fullScreen?: boolean;
  maxWidth?: false | Breakpoint;
  fullWidth?: boolean;
  sx?: SxProps;
  dialogTitle: string;
  dialogSubTitle?: string;
  dialogHeader?: React.ReactNode;
  dialogContent?: React.ReactNode;
  dialogActions?: React.ReactNode;
  isActionDialog?: boolean;
  contentSx?: SxProps;
  dividerSx?: SxProps;
  scroll?: "body" | "paper";
}

export const DialogComponent: React.FC<IDialogComponentProps> = (props) => {
  const {
    isShowModal,
    showModalMethod,
    fullScreen = false,
    maxWidth = false,
    fullWidth = false,
    sx,
    dialogTitle,
    dialogSubTitle,
    dialogHeader,
    dialogContent,
    dialogActions,
    isActionDialog = true,
    contentSx,
    dividerSx,
    scroll = "body",
  } = props;
  const { palette } = useTheme();
  return (
    <Dialog
      open={isShowModal}
      onClose={showModalMethod}
      fullScreen={fullScreen}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      scroll={scroll}
      PaperProps={{
        sx: {
          borderRadius: 4,
          ...sx,
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 3,
          pt: 3,
          mb: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <Typography sx={textStyle("heading", 700, 20)}>
            {dialogTitle}
          </Typography>
          {dialogSubTitle && (
            <Typography fontSize={14} sx={textStyle("label", 400, 14)}>
              {dialogSubTitle}
            </Typography>
          )}
        </Box>

        <IconButton
          onClick={showModalMethod}
          sx={{ alignSelf: "flex-start", padding: 0 }}
        >
          <CircleX />
        </IconButton>
      </Box>
      {dialogHeader && <Box sx={{ px: 3, mb: 3 }}>{dialogHeader}</Box>}
      {isActionDialog && <Divider sx={dividerSx} />}
      {dialogContent && (
        <Box
          sx={{
            p: 3,
            ...(scroll === "paper" && { overflowY: "auto" }),
            ...contentSx,
          }}
        >
          {dialogContent}
        </Box>
      )}
      {dialogActions && (
        <>
          {isActionDialog && <Divider sx={dividerSx} />}

          {dialogActions && <Box sx={{ p: 3 }}>{dialogActions}</Box>}
        </>
      )}
    </Dialog>
  );
};
